var _g, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSphereBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3280,
    height: 4198,
    viewBox: "0 0 3280 4198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2632.45 1742.11C2375.94 1742.11 2168 1959.25 2168 2227.11C2168 2494.97 2375.94 2712.11 2632.45 2712.11C2888.96 2712.11 3096.9 2494.97 3096.9 2227.11C3096.9 1959.25 2888.96 1742.11 2632.45 1742.11Z",
    fill: "url(#paint0_linear_7_25)",
    fillOpacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_7_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.4 3479.82C186.308 3079.95 317.513 2568.62 700.456 2337.75C1083.4 2106.86 1573.07 2243.88 1794.16 2643.77C2015.25 3043.64 1884.05 3554.97 1501.1 3785.84C1118.16 4016.73 628.492 3879.71 407.4 3479.82Z",
    fill: "url(#paint1_linear_7_25)",
    fillOpacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_7_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1259.48 1881.99C1515.99 1881.99 1723.93 1664.84 1723.93 1396.99C1723.93 1129.13 1515.99 911.988 1259.48 911.988C1002.97 911.988 795.027 1129.13 795.027 1396.99C795.027 1664.84 1002.97 1881.99 1259.48 1881.99Z",
    fill: "url(#paint2_linear_7_25)",
    fillOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_7_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1567.42 1390.91C1737.48 1390.91 1875.35 1246.94 1875.35 1069.35C1875.35 891.755 1737.48 747.788 1567.42 747.788C1397.35 747.788 1259.48 891.755 1259.48 1069.35C1259.48 1246.94 1397.35 1390.91 1567.42 1390.91Z",
    fill: "url(#paint3_linear_7_25)",
    fillOpacity: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_7_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3096.6 424.708C3268.29 735.216 3166.4 1132.26 2869.05 1311.53C2571.7 1490.8 2191.47 1384.42 2019.79 1073.91C1848.12 763.4 1950 366.356 2247.35 187.085C2544.7 7.81295 2924.93 114.201 3096.6 424.708Z",
    fill: "url(#paint4_linear_7_25)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7_25",
    x: 2068,
    y: 1642.11,
    width: 1128.9,
    height: 1170,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_7_25"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7_25",
    x: 0,
    y: 1925.59,
    width: 2201.56,
    height: 2272.41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_7_25"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7_25",
    x: 745.027,
    y: 861.988,
    width: 1028.9,
    height: 1070,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_7_25"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_7_25",
    x: 1239.48,
    y: 727.788,
    width: 655.873,
    height: 683.118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_7_25"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_7_25",
    x: 1836.4,
    y: 0,
    width: 1443.6,
    height: 1498.62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_7_25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_25",
    x1: 2632.45,
    y1: 2712.11,
    x2: 2632.45,
    y2: 1742.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E617C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_25",
    x1: 1501.1,
    y1: 3785.84,
    x2: 647.353,
    y2: 2369.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E617C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7_25",
    x1: 1259.48,
    y1: 911.988,
    x2: 1259.48,
    y2: 1881.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E617C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7_25",
    x1: 1567.42,
    y1: 747.788,
    x2: 1567.42,
    y2: 1390.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E617C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7_25",
    x1: 2247.35,
    y1: 187.085,
    x2: 2910.28,
    y2: 1286.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E617C3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSphereBg);
export default __webpack_public_path__ + "static/media/sphere-bg.7e0f64220028d5d7ecfd80a87b7e7248.svg";
export { ForwardRef as ReactComponent };